import { useSetRecoilState } from 'recoil';

import { isDocumentAuthenticated } from '../atoms/isDocumentAuthenticated';

export default function useSetDocumentAuthenticated() {
  return useSetRecoilState(isDocumentAuthenticated);
}
